/* tslint:disable:max-line-length */
import { Subscriber } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { CookieService } from 'app/services/cookie.service';
import { ConstantsService } from 'app/services/constants-service';

import { UserIdleService } from 'app/services/user-idle.service';
import { NavigationBarService } from 'app/header/navigationbar/navigation-bar.service';

import { UserRole } from 'app/shared/models/user-role.enum';
import { WarmUpService } from 'app/services/warmup/warmup.service';
import {environment} from '../../environments/environment';

/**
 * Authentication Guard to validate every URL requests
 * and check whether the user is logged in.
 */
@Injectable()
export class AuthenticationGuard implements CanActivate {
  isLoggedIn: Boolean;

  // @todo This section is to be improved.
  adminPageUrls: Array<string> =
    ['/surveys', '/archivals', '/processes', '/rules', '/users', '/payments', '/groups', '/rules', '/bankinstitutions', '/appactivity'];

  constructor(
    private userIdleService: UserIdleService,
    private navigationBarService: NavigationBarService,
    private cookieService: CookieService,
    private router: Router,
    private warmUpService: WarmUpService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Observable<boolean>(observer => {
      if (this.isLoggedIn) {
        // ALready logged in, don't perform verifySession, only admin check
        return this.verifyAdmin(observer, state);
      }

      const sessionId = this.cookieService.get(ConstantsService.COOKIE_SESSION_ID);

      if (sessionId === null || sessionId === '') {
        this.redirectToLogin(observer, `empty sessionId`);
      } else {
        this.userIdleService.verifySessionValidity(sessionId).subscribe(
          response => {
            if (response.flagResult && response.arrResult.status) {
              this.isLoggedIn = true;
              this.userIdleService.startSessionKeepAliveWatcher();
              // Currently assuming if the LS doesn't have users, than it will also not have
              // Appplication Types as there is no special key to separately check
              // for Application Types in LS.
              // TODO(jagpreet.singh): Improve the below logic.
              if (!this.warmUpService.checkLSHasUsers()) {
                this.warmUpService.fetchAndLoadAllApplicationTypes();
                this.warmUpService.fetchAndLoadAllUsers();
              }
              this.verifyAdmin(observer, state);
            } else {
              this.redirectToLogin(observer, `false flagResult ${response.flagResult} - status ${response.arrResult.status}`);
            }
          },
          err => {
            this.redirectToLogin(observer, `session validity error ${err}`);
          });
      }
    });
  }

  verifyAdmin(observer: Subscriber<Boolean>, state: RouterStateSnapshot) {
    // Following is relevant only if user is logged in already.
    // If non-Admin user tries to access Admin pages, redirect to Dashboard.
    if (!this.isAdminUser() && this.adminPageUrls.indexOf(state.url) >= 0) {
      this.router.navigate(['/dashboard']);
      observer.next(false);
    } else {
      observer.next(true);
    }

    observer.complete();
  }

  redirectToLogin(observer: Subscriber<Boolean>, reason: String) {
    observer.next(false);
    observer.complete();
    window.location.replace(environment.production ?
      `${window.location.pathname}${ConstantsService.LOGIN_URL}?lastPath=${window.location.href}`
      : `${ConstantsService.LOGIN_URL}?lastPath=${window.location.href}` );
  }

  isAdminUser(): boolean {
    const userRole = this.cookieService.get(ConstantsService.COOKIE_USER_ROLE);
    return userRole === UserRole.ADMIN.toString() || userRole === UserRole.SYSTEM.toString();
  }

  isDnbUser(): boolean {
    const userRole = this.cookieService.get(ConstantsService.COOKIE_USER_ROLE);
    return userRole === UserRole.DNB.toString();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication-guard.service.ts